// extracted by mini-css-extract-plugin
export default {"order-item__container":"OrderItem_order-item__container__Wp1tf"};